export const CONFIRMATION_DIALOG__DELETE_BANNER = 'CONFIRMATION_DIALOG__DELETE_BANNER';
